import Vue from "vue";
import App from "./App.vue";
import router from "./router/router.js"; // 导入路由配置
import i18n from "./i18n";

Vue.config.productionTip = false;

new Vue({
  router, // 将路由注入到 Vue 实例中
  i18n,
  render: (h) => h(App),
}).$mount("#app");
